// English UI strings. Source of truth for the `UIStrings` key set.
// Extracted verbatim from viewer.js (UI.en, ~line 93). HTML markup
// in values (e.g. <kbd>, <em>, <code>, <strong>) is preserved intentionally
// — the chrome renders these as innerHTML.

import type { UIStrings } from './index';

export const en: UIStrings = {
  'header.walkHint':         '<kbd>←</kbd> <kbd>→</kbd> walk · drag empty to pan',
  'header.docs':             'docs',
  'header.share.title':      'Share',
  'header.settings.title':   'Settings',
  'header.code.title':       'View source',
  'header.zoom.title':       'Zoom',
  'header.zoom.fit':         'Fit to screen',
  'header.search.title':     'Search (⌘K)',
  'search.placeholder':      'Search nodes…',
  'search.empty':            'No nodes match.',
  'code.eyebrow':            'source',
  'code.title':              'Code <em>· raw source</em>',
  'code.copy':               'Copy',
  'code.download':           'Download',
  'code.empty':              'No source available for this map.',
  'code.undo':               'Undo (⌘Z)',
  'code.redo':               'Redo (⌘⇧Z)',
  'code.status.saved':       'applied',
  'code.status.editing':     'editing',
  'code.status.error':       'invalid — keeping previous',
  'loading':                 'Loading lifecycle data…',
  'splash.title':            'lifecycle-map <em>— viewer</em>',
  'splash.eyebrow':          'interactive swim-lane lifecycle viewer',
  'splash.lead':             'Render any swim-lane lifecycle map from a JSON or YAML source. Five ways to load:',
  'splash.example.h':        'Try an example →',
  'splash.example.p':        'Load the hiring-pipeline example to explore the schema and interactions.',
  'splash.exampleMl.h':      'Try multi-language →',
  'splash.exampleMl.p':      'A smaller example with strings in <code>en</code>, <code>pt</code>, and <code>es</code>. Switch language in <strong>Settings → Language</strong>.',
  'splash.url.h':            'Load from URL → <code>?src=https://…</code>',
  'splash.url.p':            'Pass a JSON or YAML URL as a query param. Works with public Gists, raw GitHub URLs, or any CORS-enabled endpoint.',
  'splash.hash.h':           'Embed in URL → <code>#data=…</code>',
  'splash.hash.p':           'Self-contained URLs with gzip-compressed JSON in the fragment. Great for AI agents — no hosting needed.',
  'splash.dnd.h':            'Or just drag a file in →',
  'splash.dnd.p':            'Drop a <code>.json</code> or <code>.yaml</code> file anywhere on this page.',
  'splash.paste.h':          'Paste JSON or YAML',
  'splash.paste.render':     'Render',
  'splash.paste.cancel':     'Cancel',
  'splash.footer.docs':      'Documentation',
  'splash.footer.github':    'GitHub',
  'splash.footer.license':   'MIT License',
  'settings.title':          'Settings <em>· make it yours</em>',
  'settings.theme':          'Theme',
  'settings.appearance':     'Appearance',
  'settings.language':       'Language',
  'settings.uiLanguage':     'Interface language',
  'settings.dataLanguage':   'Map language',
  'settings.mode.light':     'Light',
  'settings.mode.dark':      'Dark',
  'settings.foot.docs':      'Read the docs',
  'settings.foot.github':    'View on GitHub',
  'settings.foot.license':   'MIT License',
  'dnd.title':               'Drop to load',
  'dnd.sub':                 "Release anywhere — we'll parse JSON or YAML",
};
